
'use strict';

import { debounce } from "lodash"
import { 
  setSubmitButton,
  setGroupValidationState,
  handlePhoneSelect,
  handleLocaleSelect,
  handleValidationEvent
} from './utils'

const DEBOUNCE_INPUT_VALIDATION_MS = 500

export const contactForms = {
  init() {
    const contactForms = document.querySelectorAll('.wpcf7-form');
    if (!contactForms.length) return;

    contactForms.forEach(contactForm => {
      const submitButton = contactForm.querySelector('button[type="submit"]')
      const myGroups = contactForm.querySelectorAll('.b-form__group:not(.b-form__group .b-form__group)');

      const responseOutput = contactForm.querySelector('.wpcf7-response-output')
      responseOutput?.classList?.add('d-none')

      contactForm.addEventListener('submit', () => {
        setSubmitButton({ submitButton, loading: true, disabled: true })
        responseOutput?.classList?.add('d-none')
      })

      contactForm.addEventListener('wpcf7spam', () => {
        setSubmitButton({ submitButton, loading: false, disabled: true })
        responseOutput?.classList?.remove('d-none')
      })

      contactForm.addEventListener('wpcf7mailfailed', () => {
        setSubmitButton({ submitButton, loading: false, disabled: false })
        responseOutput?.classList?.remove('d-none')
      })

      contactForm.addEventListener('wpcf7invalid', event => {
        const invalidFields = event?.detail?.apiResponse?.invalid_fields

        setSubmitButton({ submitButton, loading: false, disabled: true })

        if (!invalidFields) {
          return
        }

        myGroups.forEach(group => {
          const input = group.querySelector('input, textarea')

          const maybeInvalidField = invalidFields.find(
            ({ field }) => field === input.getAttribute('name')
          )

          const isValid = !maybeInvalidField

          setGroupValidationState({ group, isValid, message: maybeInvalidField?.message })
        })
      })

      contactForm.addEventListener('wpcf7mailsent', _event => {
        responseOutput?.classList?.remove('d-none')
        setSubmitButton({ submitButton, loading: false, disabled: false })

        myGroups.forEach(group => {
          const helperText = group.querySelector('.b-form__helper-text')
          group.classList.remove('b-form__group--filled');
          group.classList.remove('b-form__group--error');
          helperText.classList.remove('d-block');
        })
      }, false);

      let invalidFieldIds = []
      let invalidAcceptances = []

      const handleValidationEventDebounced = debounce(
        (event) => handleValidationEvent({ event, submitButton, invalidFieldIds, invalidAcceptances }), 
        DEBOUNCE_INPUT_VALIDATION_MS
      )

      contactForm.addEventListener(
        'blur', 
        (event) => handleValidationEvent({ event, submitButton, invalidFieldIds, invalidAcceptances }), 
        true
      )

      contactForm.addEventListener(
        'change',
        (event) => {
          handleValidationEvent({ event, submitButton, invalidFieldIds, invalidAcceptances })
        }
      )

      contactForm.addEventListener('input', handleValidationEventDebounced, true)

      myGroups.forEach(group => {
        const input = group.querySelector('input, textarea');

        ['country', 'language'].forEach(
          localeSelectType => handleLocaleSelect({ group, type: localeSelectType })
        )

        handlePhoneSelect({ group, input, submitButton, invalidFieldIds, invalidAcceptances })

        if (input) {
          input.addEventListener('input', (event) => {
            if (event.target.value.trim() !== '') {
              group.classList.add('b-form__group--filled');
            } else {
              group.classList.remove('b-form__group--filled');
            }
          });

          input.addEventListener('focus', () => {
            group.classList.add('b-form__group--focused');
          });

          input.addEventListener('blur', () => {
            group.classList.remove('b-form__group--focused');
          });
        }
      });
    });

    (function (document, window, index) {
      var inputs = document.querySelectorAll('.wpcf7-file');
      Array.prototype.forEach.call(inputs, function (input) {
        var label = input.parentElement.nextElementSibling,
          labelVal = label.innerHTML;

        input.addEventListener('change', function (e) {
          var fileName = '';
          if (this.files && this.files.length > 1)
            fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
          else
            fileName = e.target.value.split('\\').pop();

          if (fileName)
            label.querySelector('span').innerHTML = fileName;
          else
            label.innerHTML = labelVal;
        });

        // Firefox bug fix
        input.addEventListener('focus', function () {
          input.classList.add('has-focus');
        });
        input.addEventListener('blur', function () {
          input.classList.remove('has-focus');
        });
      });
    }(document, window, 0));
  },
}